import { T } from "../constants/theme";

export default function StepBar({
  step,
  total = 5,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: 28,
      }}
    >
      {Array.from({ length: total }).map((_, i) => {
        const num = i + 1;

        const done = num < step;
        const active = num === step;

        return (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              flex: i < total - 1 ? 1 : "none",
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 12,
                flexShrink: 0,
                background: done
                  ? T.green
                  : active
                  ? T.saffron
                  : T.gray200,
                color:
                  done || active ? T.white : T.gray400,
              }}
            >
              {done ? "✓" : num}
            </div>

            {i < total - 1 && (
              <div
                style={{
                  flex: 1,
                  height: 2,
                  background: done ? T.green : T.gray200,
                  margin: "0 4px",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}